/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Col_VehicleInputs */

const en_cases_col_vehicle = /** @type {(inputs: Cases_Col_VehicleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vehicle`)
};

const pt_br2_cases_col_vehicle = /** @type {(inputs: Cases_Col_VehicleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veículo`)
};

/**
* | output |
* | --- |
* | "Vehicle" |
*
* @param {Cases_Col_VehicleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_col_vehicle = /** @type {((inputs?: Cases_Col_VehicleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_VehicleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_col_vehicle(inputs)
	return pt_br2_cases_col_vehicle(inputs)
});